<template>
  <div v-show="!alarmData.length" class="padding-box no-alarm" style="overflow: hidden;">
    <div class="loader">
      <div class="face">
        <div class="circle"></div>
      </div>
    </div>
    <p style="position: absolute; bottom: 10px" class="colorLG fs-20">所有设备运行良好</p>
  </div>
  <div v-show="alarmData.length" class="padding-box">
    <i class="iconfont iconfont-arlam fs-22">&#xe624;</i>
    <span>
      未恢复报警数据
      <b class="colorDR fs-24">{{ alarmData.length }}</b>个
    </span>
    <div class="table-roll-box">
        <ul class="border-roll">
            <li>
                <div class="border-image"></div>
            </li>
            <li>
                <div class="border-image"></div>
            </li>
            <li>
                <div class="border-image"></div>
            </li>
            <li></li>
        </ul>
        <ul id="alarm-roll" class="table-roll">
            <li v-for="(item, index) in alarmData" :key="index" :class="index < 5 ? 'roll_' + index : 'roll_hide'">
                <el-row class="width100">
                    <el-col :span="15">
                      <span class="level" :class="'level' + item.level"></span>
                      <span class="text-overflow">{{ item.name }}</span>
                    </el-col>
                    <el-col :span="9">
                        <span class="small">{{ item.alarmTime }}</span>
                    </el-col>
                </el-row>
            </li>
        </ul>
    </div>
    <!-- <ul class="alarm-item">
      <li v-for="item in alarmData" :key="item.pointUuid" :class="!item.level ? 'bg-li' : ''">
        <div>
          <span class="level" :class="'level' + item.level"></span>
          <span class="text-overflow">{{ item.name }}</span>
          <small class="fr">{{ item.alarmTime }}</small>
        </div>
      </li>
    </ul> -->
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { getAlarmList } from "@/api/common";
import $ from "jquery";
import { ElRow, ElCol } from 'element-plus'
let $ul;
let timeID;
const alarmData = ref([]);
onMounted(() => {
  getAlarmList().then((res) => {
    alarmData.value = res.data;
    if (res.data.length > 4) {
                $ul = $('#alarm-roll');
                roll()
            }
  });
});
function roll() {
    clearInterval(timeID);
    timeID = setInterval(function () {
        clearInterval(timeID);
        $ul.animate({ top: "0px" }, 1000, function () {
            $ul.find("li:first").removeClass().addClass('roll_hide').appendTo($ul);

            for (var i = 0; i < 5; i++) {
                $ul.find("li").eq(i).removeClass().addClass('roll_' + i)
            }
            roll()
        })
    }, 10000);
}
</script>
<style lang="scss" scoped>
.no-alarm {
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.padding-box {
  width: 100%;
  height: calc(100% - 50px);
  padding-top: 10px;
  box-sizing: border-box;
  overflow-y: auto;
  color: #fff;
}

.loader {
  // position: absolute;
  width: 20em;
  height: 20em;
  font-size: 10px;
  position: relative;
  display: flex;
  flex: 0 0 20em;
  align-items: center;
  justify-content: center;
  background: url(~@/assets/noAlarm.png) no-repeat 50% 50%;
}

.loader .face {
  position: absolute;
  border-radius: 50%;
  border-style: solid;
  animation: animate 3s linear infinite;
}

.loader .face {
  width: 70%;
  height: 70%;
  color: #7AC1FF;
  border-color: currentColor currentColor transparent transparent;
  border-width: 0.2em 0em 0em 0.2em;
  --deg: -135deg;
  animation-direction: reverse;
}

.loader .face .circle {
  position: absolute;
  width: 50%;
  height: 0.1em;
  top: 50%;
  left: 50%;
  background-color: transparent;
  transform: rotate(var(--deg));
  transform-origin: left;
}

.loader .face .circle::before {
  position: absolute;
  top: -0.5em;
  right: -0.5em;
  content: '';
  width: 1em;
  height: 1em;
  background-color: currentColor;
  border-radius: 50%;
  box-shadow: 0 0 2em,
    0 0 4em,
    0 0 6em,
    0 0 8em,
    0 0 10em,
    0 0 0 0.5em rgba(255, 255, 0, 0.1);
}

@keyframes animate {
  to {
    transform: rotate(1turn);
  }
}


// .alarm-item {
//   padding-top: 10px;
//   color: #fff;

//   .bg-li {
//     // background: radial-gradient(var(--background-bar), transparent);
//     // background: var(--modal);

//     div {
//       width: 100%;
//     }
//   }

//   li {
//     position: relative;
//     width: 100%;
//     padding: 10px 0;
//     line-height: 1;
//     border-bottom: 1px solid rgba(193, 170, 206, 0.37);
//     font-size: 16px;
//     overflow: hidden;

    .small {
      font-size: 14px;
      color: #b2b2b2;
      vertical-align: middle;
    }

//     .text-overflow {
//       display: inline-block;
//       width: 62%;
//     }
//   }

//   .el-icon-arrow-right {
//     &::before {
//       position: absolute;
//       right: 0px;
//     }
//   }

  // li:last-child {
  //   border-bottom: none;
  // }

  .level {
    display: inline-block;
    width: 8px;
    height: 16px;
    border-radius: 3px;
    margin-right: 4px;
  }

  .level1 {
    background: #fc2574;
  }

  .level2 {
    background: #f8e40e;
  }

  .level3 {
    background: #229aff;
  }

  .level4 {
    background: #c945db;
  }

  .level5 {
    background: #1ec039;
  }

.table-roll-box {
    position: relative;
    margin-top: 20px;
}

.table-roll {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    // margin-left: 20px;
    overflow: hidden;
}

.table-roll li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 36px;
    position: absolute;
    left: 0;
    transition: all 2s;
    font-size: 16px;
}

.table-roll li.roll_0 {
    // opacity: 0.5;
    top: 0;
    /* font-size:10px; */
}

.table-roll li.roll_1 {
    // opacity: 0.8;
    top: 36px;
    /* font-size:14px; */
}

.table-roll li.roll_2 {
    top: 72px;
}

.table-roll li.roll_3 {
    top: 108px;
}

.table-roll li.roll_4 {
    opacity: 0;
    top: 144px;
}

.table-roll .roll_hide {
    display: none;
}

.border-roll {
    li {
        position: relative;
        height: 36px;
        width: 100%;
    }
}
</style>